module.exports = __webpack_public_path__ + "img/1019.459be2ce.png";